import { ProjectManagementUiState } from '@/store/modules/projectManagementUi/types'

export const state: ProjectManagementUiState = {
  interacted: false,
}
